import { Box, Button, Card, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconBlueprintFilled } from '@zillow/constellation-icons';

type Props = {
  setDisplayCreateNewTaskModal: (value: boolean) => void;
};

export const NoTasksEmptyState = ({ setDisplayCreateNewTaskModal }: Props) => {
  return (
    <Card
      data-testid="empty-leases-card"
      tone="neutral"
      elevated={false}
      css={{
        paddingTop: { base: 'tight', lg: 'loose' },
        paddingInline: { base: 'tight', lg: 'looser' },
        paddingBottom: { base: 'tight', lg: 'looser' },
      }}
    >
      <Box css={{ textAlign: 'left' }}>
        <Box aria-hidden="true" css={{ marginBottom: 'default' }}>
          <Icon render={<IconBlueprintFilled />} size="md" css={{ color: 'icon.subtle' }} />
        </Box>

        <Heading level={2} textStyle="heading-xs" css={{ marginBottom: 'tightest' }}>
          Track your maintenance tasks
        </Heading>

        <Paragraph css={{ marginBottom: 'default' }}>
          Keep track of routine or emergency repairs, and their resolutions, all in one place. Create tasks, record
          costs, add photos, and more.
        </Paragraph>

        <Button tone="brand" emphasis="filled" onClick={() => setDisplayCreateNewTaskModal(true)}>
          Create new task
        </Button>
      </Box>
    </Card>
  );
};
